import React from "react";
import { isEmpty } from "lodash";
import clsx from "clsx";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
import LeftShape02 from "@/components/shapes/LeftShape02";
import FrameShape01 from "@/components/shapes/FrameShape01";
import BorderShape01 from "@/components/shapes/BorderShape01";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion,
    outerNameDescriptionLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
import LanguageVersionSelector from "@/utilities/LanguageVersionSelector";
// types
import { TMainPageLayoutV2 } from "../type";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TResource from "@/cms/types/TResource";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ELayoutType from "@/cms/enums/ELayoutType";
import EContentType from "@/cms/enums/EContentType";
import EView from "@/cms/enums/EView";
import RMDRLink from "@/components/RMDRLink";


type TRender = {
    languageVersion: TLanguageVersionList|TLanguageVersionDetail;
    languageVersionPage?: TLanguageVersionList|TLanguageVersionDetail;

    resources: TResource[];
    resourceType: EResourceType;

    childs?:TClientMainPageItemList[];
    _layoutType?:ELayoutType;
}

const RenderItems = ( props:TRender ) => {
    return props.childs?.map((item) => {
        const languageVersion = mainPageItemNameDescriptionLanguageVersion(item.languageVersions);

        return (
            <div
                key={item.id}
                className="col-xl-6 col-md-6 "
                data-aos-duration="800"
                data-aos="fade-up"
                data-aos-delay="300"
            >
                <div className="icon-items">
                    <div className="icon">
                        <RMDRImage 
                            resources={item?.resources}
                            resourceType={EResourceType.ICON}
                            alt={languageVersion?.name}
                            title={languageVersion?.name}
                        />
                    </div>
                    <div className="content">
                        <h4>
                            <RMDRLink 
                                text={languageVersion?.name}
                                title={languageVersion?.name}
                                navigationURL={languageVersion?.contentRouteNavigationURL}
                                hasNavigationDestination={item.hasDestinationNavigation}
                                redirectType={item.redirectType}
                                isShowAlways
                                variant="span"
                            />
                        </h4>
                        <RMDRComponentSanitizer languageVersion={languageVersion} valueExpr="value" variant="p" className="tw-h-[84px] tw-line-clamp-3" removeTag />
                    </div>
                </div>
            </div>
        )
    })
}

const Render = ( props:TRender ) => {
    return (
        <section className={clsx("section fix", {"section-padding":props._layoutType}, {"section-padding-2":!props._layoutType})}>
            <LeftShape02 />
            <FrameShape01 />
            <div className="container">
                <div className="about-wrapper-2">
                    <div className="row g-4">
                        <div
                            className="col-xl-6"
                            data-aos-duration="800"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <div className="about-image-items">
                                <BorderShape01 />
                                <div className="thumb">
                                    <RMDRImage 
                                        resources={props.resources}
                                        resourceType={props.resourceType}
                                        alt={props.languageVersion?.name}
                                        title={props.languageVersion?.name}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="about-content">
                                <div className="section-title">
                                    <h2
                                        data-aos-duration="800"
                                        data-aos="fade-up"
                                        data-aos-delay="300"
                                    >
                                        {props.languageVersionPage?.name}
                                    </h2>
                                </div>
                                <RMDRComponentSanitizer 
                                    languageVersion={props.languageVersionPage} 
                                    valueExpr="value" 
                                    variant="div" 
                                    removeTag 
                                    className="mt-3 mt-md-0 section-content"
                                    extraData={{
                                        "data-aos-duration": "800",
                                        "data-aos": "fade-up",
                                        "data-aos-delay": "500"
                                    }}
                                />
                                <div className="row g-4 mt-4">
                                    <RenderItems {...props} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

const RenderDetails = ( props:TMainPageLayoutV2 ) => {
    console.log("MNPG054.RenderDetails", props); 

    if ( !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.params["contentDetails"].languageVersions);
    const languageVersionPage = LanguageVersionSelector<TLanguageVersionDetail|undefined>({
        languageVersions: props.params["contentDetails"].languageVersions,
        filters: [
            { view: EView.INNER, contentType: EContentType.PAGE }
        ],
        type: "find"
    });

    const childs = props.templates?.filter((item) => item.parentId === props.template?.id)

    if ( !languageVersion || isEmpty(languageVersion) ) return null;

    return <Render 
        languageVersion={languageVersion} 
        languageVersionPage={languageVersionPage}
        resources={props.params["contentDetails"].resources} 
        resourceType={EResourceType.INNER_IMAGE} 
        childs={childs}
        _layoutType={props._layoutType}
    />

}

const RenderTemplate = ( props:TMainPageLayoutV2 ) => {
    console.log("MNPG054.RenderTemplate", props); 

    if ( !props.template || isEmpty(props.template) ) return null;

    const languageVersion = mainPageItemNameDescriptionLanguageVersion(props.template.languageVersions);
    const childs = props.templates?.filter((item) => item.parentId === props.template?.id)

    if ( !languageVersion || isEmpty(languageVersion) ) return null;

    return <Render 
        languageVersion={languageVersion}
        languageVersionPage={languageVersion}
        resources={props.template.resources} 
        resourceType={EResourceType.OUTER_IMAGE} 
        childs={childs}
        _layoutType={props._layoutType}
    />

}

const MNPG054 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG054.rendered", props); 

    if ( !props.template || isEmpty(props.template) ) return null;

    if ( props._layoutType === ELayoutType.MAIN_PAGE ) {
        return <RenderTemplate {...props} />
    }
    else {
        return <RenderDetails {...props} />
    }
}

const Component = React.memo(MNPG054, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG054.memo", { prevProps, nextProps });
    return true;
});

export default Component;
